<template>
  <div>
    <account-verification-modal
        :is-dialog-visible="isAccountVerificationModalVisible"
        :is-verification-override="false"
        :on-close-action="onCloseAction"
        @visibilityChanged="setIsAccountVerificationModalVisible" />
    <account-verification-modal
        :is-dialog-visible="isAccountVerificationOverrideModalVisible"
        :is-verification-override="true"
        :on-close-action="onCloseAction"
        @visibilityChanged="setIsAccountVerificationOverrideModalVisible" />
    <revoke-verification-modal
        :is-dialog-visible="isAuthorizationRevokeModalVisible"
        @visibilityChanged="setIsAuthorizationRevokeModalVisible" />


    <div class="customer-field">
      <!-- New UI Account Verification flow -->
      <div v-if="isVerifyAccountButtonVisible">
        <el-button
            :disabled="isVerifyAccountDisabled"
            style="margin-bottom: 10px"
            class="custom-el-button"
            size="small"
            type="primary"
            plain
            @click="showAccountVerificationModal">
          Verify Account
        </el-button>
        <LinkButton
            v-if="isVerifyOverrideButtonVisible"
            :disabled="isVerifyAccountDisabled"
            @click="showAccountOverrideVerificationModal">
          Verify Override
        </LinkButton>
      </div>

      <div v-if="isRevokeAuthButtonVisible">
        <el-button
            slot="reference"
            class="custom-el-button"
            size="small"
            style="margin-bottom: 10px"
            plain
            type="primary"
            @click="showRevokeAuthorizationModal">
          Revoke Auth
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AccountVerificationModal from "@/NewUI/components/customer/authorizations/shared/AccountVerificationModal";
import RevokeVerificationModal from "@/NewUI/components/customer/authorizations/revoke/RevokeVerificationModal";
import permission from "@/mixins/permission";
import LinkButton from "@/NewUI/components/core/LinkButton";

export default {
  name: "AccountVerificationButtons",
  components: {
    AccountVerificationModal,
    RevokeVerificationModal,
    LinkButton,
  },
  mixins: [permission],

  props: {
    isVerifyAccountButtonVisible: {
      type: Boolean,
      required: true,
    },
    isVerifyOverrideButtonVisible: {
      type: Boolean,
      required: true,
    },
    isRevokeAuthButtonVisible: {
      type: Boolean,
      required: true,
    },
    isVerifyAccountDisabled: {
      type: Boolean,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    onCloseAction: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      isAccountVerificationModalVisible: false,
      isAccountVerificationOverrideModalVisible: false,
      isAuthorizationRevokeModalVisible: false,
    };
  },
  methods: {
    setIsAccountVerificationModalVisible(value) {
      this.isAccountVerificationModalVisible = value;
    },
    setIsAccountVerificationOverrideModalVisible(value) {
      this.isAccountVerificationOverrideModalVisible = value;
    },
    setIsAuthorizationRevokeModalVisible(value) {
      this.isAuthorizationRevokeModalVisible = value;
    },
    showAccountVerificationModal() {
      this.isAccountVerificationModalVisible = true;
    },
    showAccountOverrideVerificationModal() {
      this.isAccountVerificationOverrideModalVisible = true;
    },
    showRevokeAuthorizationModal() {
      this.isAuthorizationRevokeModalVisible = true;
    },
  },
};
</script>

<style scoped></style>
